<div [formGroup]="formGroup">
    <sc-checkbox-field formControlName="active" [label]="'preloading' | translate:['tmc-yard.entity.transport.masterdata.preloading', translationService.language]"></sc-checkbox-field>
    <ng-container *ngIf="transport?.masterdata.preloading">
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-date-time-field formControlName="date" [label]="'preloading time' | translate:['tmc-yard.entity.transport.masterdata.preloadingDate', translationService.language]"></sc-date-time-field>
    </ng-container>
</div>